export default __webpack_public_path__ + "safer_chat_icon.7d803942.png";